import * as Comlink from "comlink";
import { isServer } from "util/browser-utils";

let analyse = () => {};

if (!isServer()) {
    analyse = Comlink.wrap(
        new Worker(new URL(`util/mediainfo.js`, import.meta.url), {
            type: `module`
        })
    );
}

export const mediainfoAnalyse = async (blob) => {
    const requestChunk = (chunkSize, offset) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                if (event.target.error) {
                    reject(event.target.error);
                }
                resolve(new Uint8Array(event.target.result));
            };
            reader.readAsArrayBuffer(blob.slice(offset, offset + chunkSize));
        });

    const result = await analyse(blob.size, Comlink.proxy(requestChunk));

    return JSON.parse(result);
};
